import React, { Component } from "react";

import { Link } from "react-router-dom";
import Modal from "react-modal";
import USER_STATUSES from "../constants/userStatuses";
import { compose } from "recompose";
import { connect } from "react-redux";
import withAuthorization from "../components/withAuthorization";

class SubscriptionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }

  componentDidMount() {
    const { ucdUser: user } = this.props;
    if (
      user !== null &&
      user.status <= USER_STATUSES.approved &&
      user.accountType === "sugar_baby"
    ) {
      this.togglePopup();
      setInterval(this.togglePopup.bind(this), 20000);
    }
  }

  togglePopup() {
    this.setState(
      {
        isModalOpen: true
      },
      () => {
        setTimeout(() => {
          this.setState({
            isModalOpen: false
          });
        }, 10000);
      }
    );
  }

  render() {
    const { ucdUser: user } = this.props;
    const { isModalOpen } = this.state;
    return (
      <div>
        {user !== null &&
          user.status <= USER_STATUSES.approved &&
          user.accountType === "sugar_baby" && (
            <Modal
              isOpen={isModalOpen}
              shouldCloseOnOverlayClick
              onRequestClose={() => {
                return false;
              }}
              className={"subscription-modal"}
              contentLabel="Example Modal"
              style={{
                content: {
                  top: "50%",
                  bottom: "auto",
                  left: "50%",
                  right: "auto",
                  transform: "translate(-50%, -50%)"
                }
              }}
            >
              <div className="title">
                RECEIVE $50 NOW IN ADVANCE OF YOUR DATE
              </div>
              <div className="content text-center">
                <div className="message">
                  <p>
                    In order to confirm your account, please fill in your
                    payment details.
                  </p>
                  <Link className="btn btn-primary" to="/subscribe">
                    Confirm account
                  </Link>
                </div>
              </div>
            </Modal>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser
});

const mapDispatchToProps = dispatch => ({
  onChatRoomSelected: (openRoom, user) =>
    dispatch({
      type: "SET_OPEN_ROOM",
      openRoom,
      openChatDrawer: openRoom !== false,
      user
    }),
  onSetAuthUser: (authUser, ucdUser) =>
    dispatch({ type: "AUTH_USER_SET", authUser, ucdUser })
});

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SubscriptionModal);



// WEBPACK FOOTER //
// ./src/components/SubscriptionModal.js